import React, { lazy, Suspense } from 'react';
import { ResetPasswordProps } from './index';

const LazyconfirmPassword = lazy(() => import('./index'));

const confirmPassword = (props:ResetPasswordProps) => (
  <Suspense fallback={null}>
    <LazyconfirmPassword {...props} />
  </Suspense>
);

export default confirmPassword;
